export const validatePhoneDDD = (phone) => {
  return phone.length === 2;
};

export const validatePhone = (phone) => {
  const digitsOnly = phone.replace(/\D/g, "");
  return digitsOnly.length >= 8 && digitsOnly.length <= 11;
};

export const validatePhoneWithDDD = (phone) => {
  // Remove any non-numeric characters from the phone number
  const numericPhone = phone.replace(/\D/g, "");

  // Remove the first two digits (DDD) from the numeric phone number
  const phoneWithoutDDD = numericPhone.slice(2);

  // Check if the phone number without the DDD is between 6 and 9 digits,
  // or if it starts with "8" or "9"
  return (
    (phoneWithoutDDD.length >= 8 && phoneWithoutDDD.length <= 9) ||
    phoneWithoutDDD.startsWith("8") ||
    phoneWithoutDDD.startsWith("9")
  );
};

export const validateEmail = (email) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailPattern.test(email);
};

export const validateCEP = (cep) => {
  return cep.length === 8;
};

export const validateValue = (value) => {
  return !!value;
};

export const validateString = (value, minLength = null) => {
  if (!value) {
    return false;
  }

  if (typeof value !== "string") {
    return false;
  }

  const minimumLength = minLength || 0;
  return value.trim().length > minimumLength;
};

export const validateOnlyNumbersIdentification = (value) => {
  if (!value) {
    return false;
  }

  const onlyNumbers = value.replace(/\D/g, "");
  return onlyNumbers.length === 11 || onlyNumbers.length === 14;
};

export const validateOnlyNumbersCNPJ = (value) => {
  if (!value) {
    return false;
  }

  const onlyNumbers = value.replace(/\D/g, "");
  return onlyNumbers.length === 14;
};

export const validateArray = (values = []) => {
  return !values.some((value) => value === null);
};

export const validateArrayMinMaxLength = (
  array = [],
  minLength = 0,
  maxLength = 0
) => {
  return array.length >= minLength && array.length <= maxLength;
};

export const validateArrayIncludes = (array, value) => {
  return array.includes(value);
};

export const isAddressValid = (address) => {
  if (!address) return false;

  // Check for required fields
  const hasRequiredFields =
    address.street &&
    address.cep &&
    address.neighborhood &&
    address.house_number;

  // Check for valid coordinates
  const hasValidCoordinates =
    address.lat !== undefined &&
    address.lat !== null &&
    address.lat !== "" &&
    address.long !== undefined &&
    address.long !== null &&
    address.long !== "";

  return hasRequiredFields && hasValidCoordinates;
};

export const isOwner = (value) => {
  return value === 0;
};

export const isManager = (value) => {
  return value === 1;
};

export const canManage = (value) => {
  return value < 2;
};
